var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item flex"},[_c('div',{staticClass:"content-item-label"},[_vm._v("接种针次")]),_c('div',{staticClass:"inoculation"},[_c('el-input',{attrs:{"size":"small","controls":false,"maxlength":"50","controls-position":"right"},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}}),_vm._v("针 ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }